const AppSettings = {
  apiUrlOld: process.env.REACT_APP_API_OLD_URL,
  apiUrl: process.env.REACT_APP_API_URL,
};

export default AppSettings;
